/**
 * Notification Service
 * Handles notification API calls
 */

import api from './api';

export const notificationService = {
  // Get all notifications with pagination
  getNotifications: async (page = 1, limit = 20, unreadOnly = false) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      unreadOnly: unreadOnly.toString(),
    });
    return api.get(`/notifications?${params}`);
  },

  // Get unread notification count
  getUnreadCount: async () => {
    return api.get('/notifications/unread-count');
  },

  // Mark a notification as read
  markAsRead: async (notificationId) => {
    return api.put(`/notifications/${notificationId}/read`);
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    return api.put('/notifications/read-all');
  },

  // Delete a notification
  deleteNotification: async (notificationId) => {
    return api.delete(`/notifications/${notificationId}`);
  },

  // Delete all notifications
  deleteAllNotifications: async () => {
    return api.delete('/notifications');
  },
};

export default notificationService;
